import React from "react";
import { Route, Switch } from "react-router-dom";
import VehiclesTable from "./VehiclesTable";
import VehiclesForm from "./VehiclesForm";
import WriteRoute from "../../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/assets/vehicles" component={VehiclesTable} />
    <WriteRoute
      exact
      path="/assets/vehicles/addnew"
      component={VehiclesForm}
      redirectTo="/assets/vehicles"
    />
  </Switch>
);
